import React, { useEffect, useState } from 'react';
import useEditFormScroll, { editHighlightStyle } from '../hooks/useEditFormScroll';

function UomMaster({ token }) {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ uom_name: '', is_active: true });
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');
  const { formRef, editHighlight, scrollToForm } = useEditFormScroll();

  const headers = (extra = {}) => ({ Authorization: `Bearer ${token}`, ...extra });

  useEffect(() => {
    loadRows();
  }, [token]);

  const loadRows = () => {
    fetch('/api/uom-master', { headers: headers() })
      .then(res => res.json())
      .then(data => setRows(Array.isArray(data) ? data : []))
      .catch(() => {
        setRows([]);
        setError('Failed to load UOM master');
      });
  };

  const handleSave = async () => {
    if (!String(form.uom_name || '').trim()) {
      setError('UOM name required');
      return;
    }
    try {
      const res = await fetch(editingId ? `/api/uom-master/${editingId}` : '/api/uom-master', {
        method: editingId ? 'PUT' : 'POST',
        headers: headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) return setError(data.error || 'Save failed');
      setError('');
      setEditingId(null);
      setForm({ uom_name: '', is_active: true });
      loadRows();
    } catch {
      setError('Network error');
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await fetch(`/api/uom-master/${id}`, { method: 'DELETE', headers: headers() });
      const data = await res.json();
      if (!res.ok) return setError(data.error || 'Delete failed');
      setError('');
      loadRows();
    } catch {
      setError('Network error');
    }
  };

  return (
    <div className="page-shell">
      <h2 style={{ color: 'var(--theme-primary-dark)' }}>UOM Master</h2>
      {error && <div className="error-banner">{error}</div>}
      <div className="filter-bar" ref={formRef} style={editHighlightStyle(editHighlight)}>
        <h3>{editingId ? 'Edit UOM' : 'Add UOM'}</h3>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(220px, 1fr))', gap:'1rem' }}>
          <input value={form.uom_name} placeholder="UOM Name" onChange={e => setForm({ ...form, uom_name: e.target.value })} style={{ padding:'0.75rem', border:'1px solid #dcdde1', borderRadius:'6px' }} />
          <label style={{ display:'flex', alignItems:'center', gap:'0.5rem' }}>
            <input type="checkbox" checked={form.is_active} onChange={e => setForm({ ...form, is_active: e.target.checked })} />
            Active
          </label>
        </div>
        <div style={{ marginTop:'1rem', display:'flex', gap:'0.75rem' }}>
          <button onClick={handleSave} className="btn-primary" style={{ padding:'0.75rem 1.2rem', border:'none', borderRadius:'6px' }}>{editingId ? 'Update' : 'Add'}</button>
          {editingId && <button onClick={() => { setEditingId(null); setForm({ uom_name: '', is_active: true }); }} className="btn-muted" style={{ padding:'0.75rem 1.2rem', border:'none', borderRadius:'6px' }}>Cancel</button>}
        </div>
      </div>

      <h3>UOM List</h3>
      {rows.length === 0 ? <p>No UOM rows found</p> : (
        <table style={{ width:'100%', borderCollapse:'collapse', background:'#fff' }}>
          <thead>
            <tr style={{ background:'var(--theme-primary-dark)', color:'#fff' }}>
              <th style={{ padding:'0.75rem', textAlign:'left' }}>ID</th>
              <th style={{ padding:'0.75rem', textAlign:'left' }}>UOM</th>
              <th style={{ padding:'0.75rem', textAlign:'left' }}>Active</th>
              <th style={{ padding:'0.75rem', textAlign:'left' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={row.id} style={{ borderBottom:'1px solid #dcdde1' }}>
                <td style={{ padding:'0.75rem' }}>{row.id}</td>
                <td style={{ padding:'0.75rem' }}>{row.uom_name}</td>
                <td style={{ padding:'0.75rem' }}>{row.is_active ? 'Yes' : 'No'}</td>
                <td style={{ padding:'0.75rem', display:'flex', gap:'0.5rem' }}>
                  <button onClick={() => { setEditingId(row.id); setForm({ uom_name: row.uom_name || '', is_active: row.is_active !== false }); setError(''); scrollToForm(); }} style={{ border:'none', borderRadius:'4px', padding:'0.4rem 0.8rem', background:'#3498db', color:'#fff' }}>Edit</button>
                  <button onClick={() => handleDelete(row.id)} className="btn-danger" style={{ border:'none', borderRadius:'4px', padding:'0.4rem 0.8rem' }}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default UomMaster;
